import { useBuilderStore } from "../../../../Hooks/useBuilderStore";
import { TokenTypeButton } from "../shared/TokenTypeButton";
import { HEADING_LEVELS } from "./constants";

export const Headings = () => {
  const toggleSidebarView = useBuilderStore(state => state.toggleSidebarView);
  return (
    <>
      {HEADING_LEVELS.map(heading => (
        <TokenTypeButton
          key={heading.value}
          tokenType={heading}
          onClick={() => toggleSidebarView(heading.actionView)}
        />
      ))}
    </>
  );
};
